import React from "react";
import Guideline from "./component/guideline.js";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import MainContent from "./component/MainContent.js";
import Ulster from "./component/Ulster.js";
const url = window.location.href;
let brand ="rbs";
if (url.includes("ulsterbank")){
    brand = "ubn";
}
else if (url.includes("natwest")){
    brand = "nwb";
}
 function App () {
  return (
    <Router>
      <Switch>
        <div className="App">
          {brand === 'ubn'?(
          <Route path="/" exact component={Ulster} />):(
          <Route path="/" exact component={MainContent} />
  )}
          <Route path="/guideline" component={Guideline} />
        </div>
      </Switch>
    </Router>
  );
}

export default App;